/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateUrlaubsanspruchDto } from '../../models/update-urlaubsanspruch-dto';
import { UrlaubsanspruchDto } from '../../models/urlaubsanspruch-dto';

export interface UpdateUrlaubsanspruch$Json$Params {

/**
 * ID des Urlaubsanspruch
 */
  id: string;
  
    /**
     * Aktualisierte Werte für den Urlaubsanspruch
     */
    body?: UpdateUrlaubsanspruchDto
}

export function updateUrlaubsanspruch$Json(http: HttpClient, rootUrl: string, params: UpdateUrlaubsanspruch$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<UrlaubsanspruchDto>> {
  const rb = new RequestBuilder(rootUrl, updateUrlaubsanspruch$Json.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UrlaubsanspruchDto>;
    })
  );
}

updateUrlaubsanspruch$Json.PATH = '/v1/urlaubsansprueche/{id}';
